import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import type { IPersonalDataProtectionStorage } from '../../interfaces/personal-data-protection-persistence.storage';

@Injectable()
export class CookieStore implements IPersonalDataProtectionStorage {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly cookieService = inject(CookieService);

    private readonly path = '/';
    private readonly expires = 3650;

    public get<T>(key: string, defaultValue?: T | null): T | null {
        return (this.cookieService.get(key) || defaultValue) as T;
    }

    public set<T>(key: string, value: T): void {
        this.cookieService.set(key, value.toString(), this.expires, this.path, this.getCookieDomain(), false, 'Lax');
    }

    // the cookie needs to share between projects on subdomains
    private getCookieDomain(): string | null {
        if (isPlatformBrowser(this.platformId)) {
            const hostname = window.location.hostname;
            const secondLevelDomainMatch = hostname.match(/[a-z0-9-]+\.[a-z0-9-]{2,3}$/);

            return secondLevelDomainMatch ? '.' + secondLevelDomainMatch.pop() : hostname;
        } else {
            return null;
        }
    }
}
